import { render, staticRenderFns } from "./LbaDragAndDropList.vue?vue&type=template&id=0ef3a472"
import script from "./LbaDragAndDropList.vue?vue&type=script&lang=js"
export * from "./LbaDragAndDropList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports